module.exports = __webpack_public_path__ + "static/media/21.58783534.png";